const UP = 38;
const DOWN = 40;
const ENTER = 13;
const ESC = 27;
const TAB = 9;
const SPACE = 32;

export { UP, DOWN, ENTER, ESC, SPACE, TAB };

export const isKeyCodeOrKeyInList = (event, keyList) => {
  if (keyList.includes(event.keyCode) || keyList.includes(event.key)) {
    return true;
  }

  return false;
};
export const isKeyCodeOrKeyInListWithShift = (event, keyList) => {
  if (event.shiftKey && (keyList.includes(event.keyCode) || keyList.includes(event.key))) {
    return true;
  }
  return false;
};
export const isKeyCodeOrKeyInListWithCtrl = (event, keyList) => {
  if (event.ctrlKey && (keyList.includes(event.keyCode) || keyList.includes(event.key))) {
    return true;
  }
  return false;
};
